<template>
  <div class="adBnr">
    <aside class="adBnr__box">
      <adsense
      ad-client="ca-pub-7863370664678184"
      ad-slot="8250737602"
      ad-style="display:block"
      ad-format="auto">
      </adsense>
    </aside>
  </div>
</template>

<script>
export default {
  name: "AdBnr",
  data() {
    return {};
  },
  computed: {},
  methods: {},
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
.adBnr {
  width: 100%;
  padding: 10px;
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  margin: 0 auto;

  &__box{
    max-width: 1000px;
    max-height: 180px;
    margin: 0 auto;
  }
}

@media print {
  .adBnr {
    display: none;
  }
}
</style>
